export enum CustomerJobseekerViewEventSourceEnum {
  CvDatabase = 1,
  Announcement = 2,
  CvBox = 3,
  Matching = 4,
}
